var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    name: 'commonBread',
    computed: __assign({}, mapState('common', {
        commonBread: 'commonBread',
    }), { prewRouterName: function () {
            return this.commonBread.prewRouterName;
        },
        prewName: function () {
            return this.commonBread.prewName;
        },
        currentName: function () {
            return this.commonBread.currentName;
        } }),
    data: function () {
        return {};
    },
});
